import type { Page } from "../types";

export const getDocument = (element: Element): Document =>
  element.ownerDocument || document;

export const getWindow = (element: Element): typeof window =>
  getDocument(element).defaultView || window;

export const isHTMLElement = (
  element: Element | null
): element is HTMLElement =>
  element != null &&
  (element instanceof HTMLElement ||
    element instanceof getWindow(element).HTMLElement);

export const isHTMLCanvasElement = (element: Element) =>
  element instanceof HTMLCanvasElement ||
  element instanceof getWindow(element).HTMLCanvasElement;

export const getPageFromElement = (target: HTMLElement): Page | null => {
  const node = target.closest(".page");

  if (!isHTMLElement(node)) {
    return null;
  }

  const number = Number(node.dataset.pageNumber);

  return { node, number } as Page;
};

export const findOrCreateContainerLayer = (
  container: HTMLElement,
  className: string,
  selector?: string
): Element | null => {
  const doc = getDocument(container);
  let layer = container.querySelector(selector ? selector : `.${className}`);

  if (!layer) {
    layer = doc.createElement("div");
    layer.className = className;
    container.appendChild(layer);
  }

  return layer;
};
